<div class="welcome-container" data-qa="onboarding-complete">
  <div class="welcome-icon" data-qa="welcome-icon">
    <span class="icon si si-ai-logo" data-qa="ai-logo"></span>
  </div>
  <div class="text" data-qa="welcome-text">
    @if (processingProfile()) {
      <div class="welcome-title" data-qa="processing-title">We're building your profile for you!</div>
      <div class="welcome-subtitle" data-qa="processing-subtitle">
        To boost your visibility, we're building your supplier profile using
        details from your website. This ensures you are featured in our
        AI-powered supplier discovery platform.<br /><br />
        Once your profile is ready, we'll notify you-be sure to review and
        complete it to stand out and win more opportunities.
      </div>
    } @else {
      <div class="welcome-title" data-qa="manual-title">Time to build your profile!</div>
      <div class="welcome-subtitle" data-qa="manual-subtitle">
        To boost your visibility, make sure you build our your profile. This
        ensures you're featured in our AI-powered supplier discovery platform.
      </div>
    }
  </div>
  <div class="welcome-actions" data-qa="welcome-actions">
    @if (!processingProfile()) {
      <s-button
        type="primary"
        [label]="'Go to my profile'"
        (click)="continueToProfile()"
      ></s-button>
    } @else {
      <s-button
        type="primary"
        [label]="'Continue to Sustainment'"
        (click)="continueToHp()"
      ></s-button>
    }
  </div>
</div>
